export default () => {
  // Clones are held off-DOM until every page has loaded. Appending them as they
  // arrive leaves them stacked on the first tile (they inherit its Isotope
  // position) until the final arrange.
  const pending = document.createDocumentFragment();

  function finishLoading() {
    const container = document.querySelector('.material-selector__list.material-library');

    if (container) {
      container.appendChild(pending);
    }

    if (window.iso) {
      window.iso.reloadItems();
      window.iso.arrange({ filter: '*' });
    }
  }

  function loadAll(trigger) {
    if (!trigger) {
      finishLoading();

      return;
    }
    loadMore(trigger, () => {
      const nextTrigger = document.querySelector('[data-next-url]');

      loadAll(nextTrigger);
    });
  }

  function loadMore(trigger, doneLoading) {
    const nextUrl = trigger.dataset.nextUrl;

    fetch(nextUrl)
      .then(response => {
        return response.text();
      })
      .then(text => {
        const data = JSON.parse(text);
        const container = document.querySelector('.material-selector__list.material-library');
        const template = container.querySelector('.material-selector__color');

        data.materials.forEach(material => {
          const copy = template.cloneNode(true);

          copy.removeAttribute('style');
          copy.className = `material-selector__color material-selector__${material.filter.type} material-selector__${material.filter.range.replace(/\s+/g, '-').toLowerCase()} material-selector__${material.filter.tone}`;

          copy.querySelector('a').href = material.url;
          copy.querySelector('img').src = material.image;
          copy.querySelector('.material-selector__name').textContent = material.title;
          copy.querySelector('.material-selector__group').textContent = material.filter.range;

          pending.appendChild(copy);
        });

        if (data.pagination.next_url && data.pagination.next_url !== null) {
          trigger.dataset.nextUrl = data.pagination.next_url;
        } else {
          trigger.remove();
        }

        doneLoading();
      })
      .catch(error => {
        console.error('Error loading more materials:', error);
        trigger.remove();
        finishLoading();
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    loadAll(document.querySelector('[data-next-url]'));
  });
}
